import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark px-3"
      style={{ backgroundColor: "#224b8f" }}
    >
      {/* Hamburger – LEFT */}
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#mainNav"
        aria-controls="mainNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* Logo */}
      <span
        className="navbar-brand fw-bold ms-2"
        style={{ cursor: "pointer" }}
        onClick={() => navigate("/")}
      >
        
      </span>

      {/* Call Now */}
      <div className="ms-auto order-lg-3">
        <button
          className="btn btn-danger"
          onClick={() => (window.location.href = "tel:09415039147")}
        >
          Call Now
        </button>
      </div>

      {/* Menu */}
      <div className="collapse navbar-collapse order-lg-2" id="mainNav">
        <ul className="navbar-nav mx-lg-auto mb-2 mb-lg-0">
  <li className="nav-item mx-3">
    <span className="nav-link" onClick={() => navigate("/")}>
      Home
    </span>
  </li>

  <li className="nav-item mx-3">
    <span className="nav-link" onClick={() => navigate("/about")}>
      About
    </span>
  </li>

  <li className="nav-item mx-3">
    <span className="nav-link" onClick={() => navigate("/product")}>
      Our Product
    </span>
  </li>

  <li className="nav-item mx-3">
    <span className="nav-link" onClick={() => navigate("/contact")}>
      Contact
    </span>
  </li>
</ul>

      </div>
    </nav>
  );
};

export default Navbar;
